import { BBox, bboxPolygon, booleanContains } from '@turf/turf';

export const createMapBoundsCriterion = (bounds: number[]) => (site: any) => {
    const boundingBoxPolygon = bboxPolygon(bounds as BBox);

    return booleanContains(boundingBoxPolygon, site.location);
};
